@if (banner && deviceService.isMobile()) {
  @if (banner?.url) {
    <a
      target="_blank"
      href="{{ banner?.url }}{{ utm(banner.url) }}"
      [id]="bannerPositionId + ' | ' + banner?.url"
      (click)="click()"
      class="app-banner-mobile-header app-banner-main text-center"
      >
      <img
        src="{{ banner.path }}"
        alt="{{ banner?.altText }}"
            srcset="{{ banner?.small_image }} 600w,
                    {{ banner?.medium_image }} 1024w,
                    {{ banner?.large_image }} 1600w"
        class="banner-parallax-img"
        />
    </a>
  } @else {
    @if (!banner?.url) {
      <img
        src="{{ banner.path }}"
        alt="{{ banner?.altText }}"
        class="app-banner-mobile-header banner-parallax-img"
            srcset="{{ banner?.small_image }} 600w,
                        {{ banner?.medium_image }} 1024w,
                        {{ banner?.large_image }} 1600w"
        />
    }
  }
}
